import React from 'react';
import { connect } from 'react-redux';
import Slideshow from './../../Slideshow.jsx';
import SocialButtons from './../../SocialButtons.jsx';
import SmallInlineVideoCard from './../small/SmallInlineVideoCard.jsx';
import smallActions from './../../../actions/small-card-actions';


class LargeTitleCard extends React.Component {
  constructor(props) {
    super(props);

    // used by React as the component name
    this.displayName = 'LargeTitleCard';

    // bind functions to component
    this.renderTopElement = this.renderTopElement.bind(this);
  }


  /**
   * Called when component props or state updates
   * @param {Object} prevProps - The previous props
   * @returns {undefined} undefined
   */
  componentDidUpdate(prevProps) {
    if (this.node) {
      const state = this.props.largeCardFrameworkState;
      const smallState = this.props.smallCardFrameworkState;

      if ((state.scrollTop !== prevProps.largeCardFrameworkState.scrollTop) &&
        (((this.node.offsetTop + this.node.offsetHeight)
        - state.scrollTop < 0) || (this.node.offsetTop - state.scrollTop) >
        window.innerHeight)) {
        if ((smallState.currentCardIteration + 1) === this.props.data.order) {
          this.props.dispatch(smallActions.setCurrentCardIteration(this.props.data.order + 1));
        }
      } else {
        if ((smallState.currentCardIteration + 1) !== this.props.data.order) {
          this.props.dispatch(smallActions.setCurrentCardIteration(this.props.data.order));
        }
      }
    }
  }


  /**
   * Renders top element
   * @returns {ReactElement} ReactElement
   */
  renderTopElement() {
    const state = this.props.smallCardFrameworkState;
    const data = this.props.data;
    const active = (state.currentCardIteration + 1 === data.order);
    let element;

    if (data.images) {
      element = (
        <Slideshow
          active={active}
          data={data.images}
          id={data.order}
          largeBreakpoint={this.props.largeBreakpoint}
        />
      );
    } else if (data.video.large) {
      const style = {
        height: '100%',
      };

      element = (
        <SmallInlineVideoCard
          autoplay
          data={data.video.large}
          iteration={0}
          key={'title-card-video-' + data.order}
          style={style}
        />
      );
    }

    return element;
  }


  /**
   * Renders component
   * @returns {ReactElement} ReactElement
   */
  render() {
    const topElement = this.renderTopElement();
    const data = this.props.data;
    const style = {
      zIndex: this.props.iteration * 10,
    };
    const className = 'card component-large-title-card full-width';

    return (
      <section
        className={className}
        style={style}
      >
        <div className='content'>
          {topElement}
          <div className='text large-col-8 large-push-2'>
            <div className='title'>{data.title}</div>
            <div
              className='subtitle'
              dangerouslySetInnerHTML={{ __html: data.subtitle }}
            />
            <div
              className='info'
              dangerouslySetInnerHTML={{ __html: data.info }}
            />
          </div>
        </div>
        <a
          className='logo'
          href='http://bleacherreport.com/br-mag'
        />
        <SocialButtons
          shareText={data.title}
          shareUrl={window.location.href}
        />
      </section>
    );
  }
}


/**
 * Expected propTypes
 * @prop {Object} data - An array of card React components
 * @prop {Function} dispatch - A Redux function to dispatch events
 * @prop {Number} iteration - The iteration of the component
 * @prop {Number} largeBreakpoint - The screen width at which the large image
 * size should be shown
 * @prop {Object} largeCardFrameworkState - The state of the
 * LargeCardFramework component
 * @prop {Object} mediaLabCardFrameworkState - The state of the
 * container component
 * @prop {Object} smallCardFrameworkState - The state of the
 * SmallCardFramework component
 * @prop {Object} style - A style object
 */
LargeTitleCard.propTypes = {
  data: React.PropTypes.object.isRequired,
  dispatch: React.PropTypes.func,
  iteration: React.PropTypes.number.isRequired,
  largeBreakpoint: React.PropTypes.number.isRequired,
  largeCardFrameworkState: React.PropTypes.object.isRequired,
  mediaLabCardFrameworkState: React.PropTypes.object.isRequired,
  smallCardFrameworkState: React.PropTypes.object.isRequired,
  style: React.PropTypes.object,
};


export default connect(({ mediaLabCardFrameworkState, largeCardFrameworkState, smallCardFrameworkState }) =>
  ({ mediaLabCardFrameworkState, largeCardFrameworkState, smallCardFrameworkState }))(LargeTitleCard);



/** WEBPACK FOOTER **
 ** ./assets/js/src/components/cards/large/LargeTitleCard.jsx
 **/